<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-2.538-13.954l7.458-7.463 1.414 1.414-8.834 8.84-.037-.038-.038.038-4.84-4.84L10 14.584l3.462 3.463z"/>
</svg>
